import type { SVGProps } from 'react';

const SvgPoliceMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M19.9882 19.7513C20.0785 20.4381 19.6392 21 19.0119 21H4.98815C4.36083 21 3.92146 20.4381 4.01177 19.7513L4.20935 18.2487C4.29965 17.5619 4.8868 17 5.51411 17H18.4859C19.1132 17 19.7004 17.5619 19.7907 18.2487L19.9882 19.7513Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12 3C8.13399 3 5 5.89292 5 9.46153V17H19V9.46153C19 5.8929 15.866 3 12 3Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M15 10L15 14' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgPoliceMd;
